import React, { Component } from 'react';
import UprinceNavigation from '../../shared/uprinceNavigation/cuProjectNavigation/component';
import WarehouseMainLayout from './warehouseMainLayout';
import { getContractingUnit, getProject } from '../../shared/util';


interface Props {
  currentUser: any
}

interface State {
  isContractUnit: boolean;
  isProject: boolean;
}

export class Warehouse extends Component<Props, State> {
  render() {
    return (
      <UprinceNavigation
        currentUser={this.props.currentUser}
        // selectedNavigationIndex={getProject()? `/CU/${getContractingUnit()}/project/${getProject()}/stock`:`/CU/${getContractingUnit()}/stock` }
        selectedNavigationIndex={getProject() ? `/CU/${getContractingUnit()}/project/${getProject()}/stock` : `/CU/${getContractingUnit()}/stock`}
      >
        <WarehouseMainLayout/>
      </UprinceNavigation>
    );
  }
}

export default (Warehouse);
